export default __webpack_public_path__ + "static/media/call_forward.fe37ce84.png";